module.exports = __webpack_public_path__ + "img/watermark_placeholder.7daa0e30.jpg";